const SOCIAL_NETWORKS = {
  FACEBOOK: 1,
  GOOGLE: 2,
};

export default SOCIAL_NETWORKS;
